import { GetUserAchEntitlementsModelDto as BoUserAchEntitlementsModelDto } from '@treasury/api/bo';
import { GetUserAchEntitlementsModelDto as ConsumerUserAchEntitlementsModelDto } from '@treasury/api/channel';

import { DomainEntity } from '../../../../shared';
import { AchCompany } from '../../../entities/ach-company.entity';
import { UserClaim } from './user-claim.entity';

const defaultCompanyUserAchEntitlements: BoUserAchEntitlementsModelDto = {
    achCompanies: [],
    userAchCompanies: [],
    userProductClaims: [],
};

export class CompanyUserAchEntitlements extends DomainEntity<
    BoUserAchEntitlementsModelDto | ConsumerUserAchEntitlementsModelDto
> {
    constructor(dto: BoUserAchEntitlementsModelDto | ConsumerUserAchEntitlementsModelDto) {
        super(dto);
        this.productClaims = this.dto.userProductClaims?.map(claim => new UserClaim(claim)) || [];
        this.achCompanies = this.dto.achCompanies?.map(company => new AchCompany(company)) || [];
    }

    public achCompanies: AchCompany[] = [];

    public productClaims: UserClaim[] = [];

    public createDefault(): this {
        return new CompanyUserAchEntitlements(defaultCompanyUserAchEntitlements) as this;
    }
}
